<div class="card" [ngClass]="{'card-collapsed':collapsed}">
    <div class="card-header" (click)="toggle()">
        <h4>{{headline}}</h4>
        <div class="card-header-collaps">
            <fa-icon [icon]="faMinus" *ngIf="!collapsed"></fa-icon>
            <fa-icon [icon]="faPlus" *ngIf="collapsed"></fa-icon>
        </div>
    </div>
    <div class="card-body">
        <ng-content select="app-card-body"></ng-content>
    </div>
    <div class="card-footer">
        <ng-content select="app-card-footer"></ng-content>
    </div>
</div>
